<div class="page-controllers" *ngIf="!isLoading">
  <app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>

  <div class="d-flex gap-3 horses-nav">
    <!-- Previous / Next stays — it is still the right control for browsing.
         The box beside it takes a hip number, for the visitor who was told to
         look at one (CEO review, 18 Aug 2026). -->
    <app-lot-jump
      variant="buyer"
      [lotLabel]="'lot_jump.lot' | translate"
      [entries]="lotJumpEntries"
      [loading]="lotJumpLoading"
      blockedMessageKey="lot_jump.withdrawn"
      (load)="onLotJumpLoad()"
      (jump)="onLotJump($event)"
    />

    <!-- *ngIf="catalogType == 'catalogue' " -->
    <button
      class="pointer primary-btn button--small"
      (click)="prevEntry()"
      [disabled]="!horseDetails?.nav?.previous?.id"
      [class.disabled]="!horseDetails?.nav?.previous?.id"
      data-translation-key="horse_view_previous_horse"
    >
      <i class="bi bi-arrow-right" *ngIf="localeService.dir == 'rtl'"></i>
      <i class="bi bi-arrow-left" *ngIf="localeService.dir == 'ltr'"></i>
      {{ "horse_view.previous_horse" | translate }}
    </button>
    <!-- *ngIf="catalogType == 'catalogue'" -->
    <button
      (click)="nextEntry()"
      [disabled]="!horseDetails?.nav.next?.id"
      [class.disabled]="!horseDetails?.nav?.next?.id"
      class="pointer primary-btn button--small"
      data-translation-key="horse_view_next_horse"
    >
      {{ "horse_view.next_horse" | translate }}
      <i class="bi bi-arrow-right" *ngIf="localeService.dir == 'ltr'"></i>
      <i class="bi bi-arrow-left" *ngIf="localeService.dir == 'rtl'"></i>
    </button>
  </div>
</div>
<div class="auction-details-section pt-20 mb-110" *ngIf="!isLoading">
  <div class="container-fluid mb-120">
    <div class="row gy-5">
      <!-- Left column with image gallery -->
      <div class="col-xl-7">
        <app-horse-images-gallary
          [images]="{ activeImage: activeImg, thumbnails: thumbnails }"
        ></app-horse-images-gallary>
      </div>

      <!-- Right column with bid board and details -->
      <div class="col-xl-5">
        <div
          class="auction-details-content"
          style="padding-top: 20px !important; padding-bottom: 20px !important"
        >
          <div class="auction-details">
            <div class="header">
              <h2 class="d-flex gap-2 align-items-center">
                #{{ horseDetails?.hip_number }}

                {{ horseDetails?.name }}
                <button
                  *ngIf="
                    horseDetails.withdrawn_at == null &&
                    horseDetails?.has_update
                  "
                  type="button"
                  class="info-button"
                  [matTooltip]="horseDetails?.update_content"
                  matTooltipPosition="above"
                  matTooltipClass="material-tooltip buyer-theme horse-updates"
                  [matTooltipShowDelay]="300"
                  [matTooltipHideDelay]="500"
                  [attr.aria-label]="
                    'Information about ' + horseDetails?.update_content
                  "
                  (click)="
                    $event.stopPropagation();
                    $event.preventDefault();
                    tooltip?.toggle()
                  "
                  #tooltip="matTooltip"
                >
                  <i class="bi bi-info-circle"></i>
                </button>
              </h2>
              <button
                *ngIf="auc_type !== 'upcoming'"
                class="currency-toggle"
                [ngClass]="{
                  expanded: isExpandedCurrency,
                  disabled: currencyRates?.rates?.length == 0
                }"
                (click)="toggleCurrency()"
                tabindex="0"
                attr.id="accordion-currency"
                attr.aria-controls="'accordion-currency-body'"
                [disabled]="currencyRates?.rates?.length == 0"
                [attr.aria-disabled]="currencyRates?.rates?.length == 0"
                type="button"
              >
                <i class="bx bx-world"></i>
                {{ "horse_info.currency" | translate }}
              </button>
            </div>
            <app-currency-conversions
              class="currency-panel"
              [ngClass]="{ open: isExpandedCurrency }"
              [isOpen]="isExpandedCurrency"
              (close)="toggleCurrency()"
              [currencyRates]="currencyRates"
              [convertingValue$]="convertingValue$"
              [auctionType]="auc_type"
              [currency]="currency"
              [locale]="localeService.locale"
              attr.id="accordion-currency-body"
              attr.aria-labelledby="accordion-currency"
            ></app-currency-conversions>
            <app-horse-top-details
              [canBid]="canBid"
              [loggedIn]="loggedIn"
              [horseDetails]="horseDetails"
              [aucType]="auc_type"
              [fields]="fields"
              [schema]="schema"
              [auctionSettings]="auctionSettings"
              [terms]="buyerTerms"
              [horseOffers]="{
                offers: horseDetails?.offers,
                make_an_offer: horseDetails?.make_an_offer
              }"
              [dir]="localeService.dir$ | async"
              [userId]="user_id"
              (loadData)="getData()"
              [locale]="localeService.locale"
              [currency]="currency"
              [buyerStatus]="buyerStatus"
              [sellerEmail]="sellerEmail"
            >
              <div activeDetails class="w-100">
                <ng-container *ngIf="auc_type == 'active'">
                  <div
                    *ngIf="canBid || horseDetails?.notAuthBidBoard"
                    class="timer-section"
                  >
                    <h5
                      class="timer-title"
                      data-translation-key="horse_view_bid_up_will_end_on"
                    >
                      {{ "horse_view.bid_up_will_end_on" | translate }}
                    </h5>

                    <app-timer
                      [endDate]="endAuctionDate"
                      [startDate]="startAuctionDate"
                      [currentDate]="currentDate"
                      [auc_type]="auc_type"
                      [showProgressPar]="true"
                      [countInUpcoming]="countInUpcoming"
                      (loadData)="getData($event)"
                      (canBidChanged)="canBid = $event"
                      (auctionTypeChanged)="auc_type = $event"
                      [isColon]="false"
                    ></app-timer>
                  </div>
                  <div *ngIf="isUnderReserve && canBid" class="under-reserve-text">
                    <span data-translation-key="horse_view_under_reserve_warning">
                      {{ 'horse_view.under_reserve_warning' | translate }}
                    </span>
                  </div>
                  <div *ngIf="canBid" class="bid-controls">
                    <div class="mt-2" *ngIf="!isAutoBid.value && !isBlockedOrSuspended">
                      <div class="bid-input-group">
                        <button
                          type="button"
                          class="bid-button"
                          (click)="increaseBy(-1)"
                          [disabled]="
                            horseDetails?.highest_bid_amount >= amount_num ||
                            auctionMinBid >= amount_num ||
                            nextMinBid >= amount_num ||
                            horseDetails?.min_bid >= amount_num
                          "
                        >
                          -
                        </button>

                        <div class="input-group d-flex flex-nowrap">
                          <input
                            #amountEl
                            type="string"
                            class="form-control text-center bid-input"
                            name="amount"
                            [value]="amount"
                            (input)="onAmountChange($event.target.value)"
                          />
                          <span class="input-group-text">{{
                            currency?.currency_code
                              | currencySymbol : (localeService.locale$ | async)
                          }}</span>
                        </div>

                        <button
                          type="button"
                          class="bid-button"
                          (click)="increaseBy(1)"
                        >
                          +
                        </button>
                      </div>
                      <span
                        class="error text-center mt-3"
                        *ngIf="showNotMultiError"
                        data-translation-key="bid_now_popup_bidding_validation_2"
                      >
                        {{ "bid_now_popup.bidding_validation_2" | translate }}
                        <!-- {{ currBidIn }} -->
                      </span>
                    </div>

                    <div class="bid-protection mt-3 mb-2" *ngIf="!isBlockedOrSuspended">
                      <span
                        class=""
                        data-translation-key="bid_now_popup_bid_protection"
                        >{{
                          "bid_now_popup.bid_protection" | translate
                        }}
                        :</span
                      >
                      <span
                        class="protection-badge"
                        data-translation-key="bid_now_popup_increment"
                      >
                        +
                        {{
                          currBidIn || 0
                            | customCurrency
                              : currency?.currency_code
                              : (localeService.locale$ | async)
                              : "symbol"
                              : "1.0-0"
                        }}
                        {{ "bid_now_popup.increment" | translate }}</span
                      >
                      <span class="mx-1" (click)="openBidIncrememts()">
                        <i
                          class="bx bxs-info-circle text-primary"
                          style="cursor: pointer"
                        ></i>
                      </span>
                    </div>
                    <div class="" [class.action-buttons]="!isAutoBid.value && !isBlockedOrSuspended">
                      <app-automatic-bid
                        [isAutoBid$]="isAutoBid$"
                        [isEndedAuction$]="isEndedAuction$"
                        [data]="{
                          bidsIncrements: bidsIncrements,
                          id: horseId,
                          nextMinBid: nextMinBid,
                          currBidIn: currBidIn,
                          hip_number: horseDetails?.hip_number,
                          appDir: localeService.dir,
                          translation: horseTranslation,
                          automatic_bidding: {
                            biddingValue:
                              this.horseDetails?.automatic_bidding
                                ?.automatic_bid_value
                          },
                          terms: buyerTerms,
                          locale: (localeService.locale$ | async),
                          currency: currency
                        }"
                        [flexDirection]="'column'"
                        class=""
                        [ngClass]="{ 'w-100': isAutoBid.value }"
                        (isAutoBidChanged)="onAutoBidChanged($event)"
                        [buyerStatus]="buyerStatus"
                        [sellerEmail]="sellerEmail"
                      ></app-automatic-bid>

                      <button
                        *ngIf="!isAutoBid.value && !isBlockedOrSuspended"
                        type="submit"
                        class="action-button bid-now"
                        (click)="bid()"
                        [disabled]="isBidDisabled"
                      >
                        <span
                          *ngIf="!bidClicked"
                          data-translation-key="horse_info_actions_bid_now"
                        >
                          {{ "horse_info.actions_bid_now" | translate }}
                        </span>
                        <div
                          class="d-flex justify-content-center"
                          *ngIf="bidClicked"
                        >
                          <mat-spinner [diameter]="20"></mat-spinner>
                        </div>
                      </button>
                    </div>

                    <span
                      *ngIf="
                        heighestBidType == 'user' &&
                        heighestBidderId == userData?.id
                      "
                      data-translation-key="horse_view_you_heighest_bidder"
                      class="note mt-3 d-flex justify-content-center"
                      >{{ "horse_view.you_heighest_bidder" | translate }}</span
                    >
                  </div>
                </ng-container>
              </div>
            </app-horse-top-details>
          </div>
        </div>
        <div class="auction-details-description-area">
          <div class="auction-details-description-nav mb-50">
            <nav>
              <div class="nav nav-tabs" role="tablist">
                <button
                  class="nav-link active"
                  type="button"
                  role="tab"
                  [attr.aria-selected]="true"
                  data-translation-key="horse_view_horse_details"
                >
                  {{ "horse_view.horse_details" | translate }}
                </button>
              </div>
            </nav>
          </div>
          <div class="auction-details-description-tab">
            <div class="tab-content">
              <!-- Horse Info Table -->
              <div
                class="tab-pane fade"
                [class.show]="true"
                [class.active]="true"
                role="tabpanel"
              >
                <app-horse-view-details-data
                  [fields]="fields"
                  [schema]="schema"
                  [address]="address"
                  [healthIssues]="horseDetails?.horse?.health_issues"
                >
                </app-horse-view-details-data>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="auction-details-description-area style-2 mb-110"
  *ngIf="!isLoading && horseDetails?.files?.length > 0"
>
  <div class="container">
    <div class="auction-details-description-nav mb-50">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <ng-container *ngFor="let tab of horseDetails?.files; let i = index">
            <button
              class="nav-link"
              [class.active]="selectedTab === i"
              id="nav-{{ tab.name }}-tab"
              type="button"
              role="tab"
              aria-controls="nav-{{ tab.name }}"
              [attr.aria-selected]="selectedTab === i"
              (click)="selectedTab = i"
            >
              <svg
                *ngIf="tab?.lock_type && tab.lock_action_needed"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0,0,256,256"
              >
                <g
                  fill="#fa5252"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <g transform="scale(8.53333,8.53333)">
                    <path
                      d="M15,2c-3.85433,0 -7,3.14567 -7,7v2h-2c-1.105,0 -2,0.895 -2,2v12c0,1.105 0.895,2 2,2h18c1.105,0 2,-0.895 2,-2v-12c0,-1.105 -0.895,-2 -2,-2h-2v-2c0,-3.72842 -2.96342,-6.73143 -6.64453,-6.92773c-0.11309,-0.04556 -0.23356,-0.07005 -0.35547,-0.07227zM15,4c2.77367,0 5,2.22633 5,5v2h-10v-2c0,-2.77367 2.22633,-5 5,-5z"
                    ></path>
                  </g>
                </g>
              </svg>
              {{ getCategoryName(tab.name) }}
            </button>
          </ng-container>
        </div>
      </nav>
    </div>
    <div class="auction-details-description-tab">
      <div class="tab-content" id="nav-tabContent">
        <ng-container *ngFor="let tab of horseDetails?.files; let i = index">
          <div
            class="tab-pane fade"
            [class.show]="selectedTab === i"
            [class.active]="selectedTab === i"
            id="nav-{{ tab.name }}"
            role="tabpanel"
            aria-labelledby="nav-{{ tab.name }}-tab"
          >
            <ng-container
              *ngIf="
                tab.files.length >= 1 &&
                (!tab?.lock_type ||
                  tab?.lock_type === 'unlocked' ||
                  !tab.lock_action_needed)
              "
            >
              <div class="tab" *ngFor="let file of tab.files; let i = index">
                <div
                  class="d-flex mb-3 align-items-center justify-content-end doc-header"
                >
                  <!-- <h4 class="file_name">{{ file.file_name }}</h4> -->
                  <div class="d-flex align-items-center gap-2">
                    <button
                      mat-icon-button
                      (click)="openInNewTap(file.file_url)"
                    >
                      <mat-icon class="open">open_in_new</mat-icon>
                    </button>
                  </div>
                </div>

                <div class="description-content">
                  <app-file-iframe
                    [id]="i"
                    [file]="file.file | safeUrl"
                  ></app-file-iframe>
                </div>
              </div>
            </ng-container>
            <app-lock-category
              *ngIf="tab?.lock_type && tab.lock_action_needed"
              [category]="tab?.name"
              [lockType]="tab?.lock_type"
              [loggedIn]="loggedIn"
              [horseDetails]="horseDetails"
              [aucType]="auc_type"
              [auctionSettings]="auctionSettings"
            ></app-lock-category>
            <div
              *ngIf="
                !isLoading &&
                tab.files.length == 0 &&
                (!tab?.lock_type ||
                  tab?.lock_type === 'unlocked' ||
                  !tab.lock_action_needed)
              "
              class="no_data"
              data-translation-key="horse_view_no_docs"
            >
              {{ "horse_view.no_docs" | translate }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div
  id="notes-section"
  class="auction-details-description-area style-2 mb-110"
  *ngIf="!isLoading && loggedIn"
>
  <div class="container">
    <div class="auction-details-description-nav mb-50">
      <app-horse-notes
        [horseNotes]="horseDetails?.buyer_horse_note"
        [auctionItemId]="horseDetails?.id"
        (notesChanged)="getData(false, false)"
        (notesUpdated)="onNotesUpdated($event)"
      ></app-horse-notes>
    </div>
  </div>
</div>

<div *ngIf="isLoading">
  <app-skeleton-loader type="horse-profile"></app-skeleton-loader>
</div>
<app-live-video-player></app-live-video-player>
